var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-pdf",attrs:{"href":_vm.link,"download":_vm.nameDescarga}},[_c('img',{attrs:{"src":require("@/assets/images/icon_pdf.png")}}),_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }